import { Component, OnInit, OnDestroy }  from '@angular/core';
import { Router, ROUTER_DIRECTIVES, ActivatedRoute } from '@angular/router';
import { UserSession } from '../../shared/user-session';

import {TraconModelService} from './tracon-model.service';
import {ITraconLocid, ITraconModelResponse, ITraconModelRequest,ITraconModelSummaryResponse,ITraconModelReforecastAOPSIFR} from './tracon-model';

import * as _ from 'lodash';

@Component({
    //templateUrl: 'app/system-management/towers-tracons-import/towers-tracons-import.component.html',
    template: require('./tracon-model.component.html'),
    styles: [require('./tracon-model.css')],
    directives: [ROUTER_DIRECTIVES],
    providers:[TraconModelService]
})
export class TraconModelComponent implements OnInit {
    pageTitle: string = 'Tracon Model';
    errorMessage: string;
    private sub: any;
    traconLocid:any;
    locid:any;
    years:any;
    traconRequest:ITraconModelRequest;
    traconResponse: any;
    traconSummaryResponse:ITraconModelSummaryResponse;
    traconReforecastAopsIfr:ITraconModelResponse;
    traconReforecast:ITraconModelResponse;
    event:any;
    showTableSummary:boolean

     constructor(private route: ActivatedRoute,
                private router: Router,
                private _traconModelService:TraconModelService,
                private _user:UserSession){ 
       this.traconRequest =new ITraconModelRequest("A11", 2012, _user.getSession().scenarioId, 2012, 2045);
       this.showTableSummary=false;
    }

     ngOnInit():void{
        this._traconModelService.getTraconList()
        .subscribe(
            traconLocid=>this.traconLocid = traconLocid,
            error => this.errorMessage = error,
            ()=>{
                this.locid = _.map(this.traconLocid,'value');
                // function(o){console.log("func:" +o.key);return o.key;});
                //_.map(JSON.parse(JSON.stringify(_.fromPairs(this.traconLocid))),'key');
                /*_.forOwn((this.traconLocid), function(value, key) {
                    console.log(value.value);
                    return value.value;
                });*/
            }
        );
        this._traconModelService.getYearsList()
        .subscribe(
            traconLocid=>this.traconLocid = traconLocid,
            error => this.errorMessage = error,
            ()=>{
                this.years = _.map(this.traconLocid,'value');
            }
        );
        
    }
    onTraconLocidChange(event: Event):void {
        let select: HTMLSelectElement = event.target as HTMLSelectElement;
        this.traconRequest.traconId = select.value;
    }    
    onYearsChange(event: Event):void {
         let select: HTMLSelectElement = event.target as HTMLSelectElement;
        //alert(typeof(select.value));
        this.traconRequest.ayear = +select.value;
        //alert(this.traconRequest.ayear);
    }
     generateReport(): void {
       this._traconModelService.getTraconResult(this.traconRequest)
                .subscribe(
                    traconResponse => this.traconResponse = traconResponse,
                    error => this.errorMessage = error,
                    ()=>{
                        this.showTableSummary=false;
                        //this.years = _.map(this.traconLocid,'value');
                        //console.log("traconResponseLocid " + this.traconResponse);
                    }
                );
    }
    generateSummaryReport(): void {
        //console.log("cancel");
        this._traconModelService.getTraconSummaryResult(this.traconRequest)
                .subscribe(
                    traconSummaryResponse => this.traconSummaryResponse = traconSummaryResponse,
                    error => this.errorMessage = error,
                    ()=>{
                        this.showTableSummary =true;
                        //this.years = _.map(this.traconLocid,'value');
                        console.log("traconSummaryResponse " + this.traconSummaryResponse);
                    }
                );
    }
    reforecastAopsIfr(): void {
        //console.log("cancel");
        this._traconModelService.reforecastAopsIfr(this.traconRequest)
                .subscribe(
                    traconReforecastAopsIfr => this.traconReforecastAopsIfr = traconReforecastAopsIfr,
                    error => this.errorMessage = error,
                    ()=>{
                        //console.log("traconSummaryResponse " + this.traconReforecastAopsIfr);
                    }
                );
    }
    reforecastTracon(): void {
        //console.log("cancel");
        this._traconModelService.reforecastAopsIfr(this.traconRequest)
                .subscribe(
                    traconReforecast => this.traconReforecast = traconReforecast,
                    error => this.errorMessage = error,
                    ()=>{
                        //console.log("traconSummaryResponse " + this.traconReforecast);
                    }
                );
    }
    
}



/** WEBPACK FOOTER **
 ** ./app/system-management/tracon-models/tracon-model.component.ts
 **/